import { ReactNode } from 'react'
import { WppTypography } from '@wppopen/components-library-react'
import type { KeyObjectType } from 'reducers/KeywordsAndPhrasesReducer/KeywordsAndPhrasesReducer.d'
import clsx from 'clsx'
import styles from '../HighlightedSpan.module.scss'

interface KeywordProps {
  type: KeyObjectType
  currentNumberOfKeywords?: number
  children: ReactNode
  onClick?: () => void
  onHover?: () => void
  onLeave?: () => void
  isInactive?: boolean
  className?: string
}

export default function HighlightedPopoverSpan({
  type,
  currentNumberOfKeywords = 0,
  children,
  isInactive,
  onClick,
  onHover,
  onLeave,
  className,
}: KeywordProps) {
  const shouldBeRoleButton = onClick && currentNumberOfKeywords

  return (
    <WppTypography
      tag="p"
      type="s-body"
      data-testid={type}
      className={clsx(className, {
        [styles.keyword]: type === 'keyword',
        [styles.keyphrase]: type !== 'keyword',
        [styles.inactive]: isInactive,
        [styles.inactive__hover]: isInactive && onClick,
        [styles.disable]: !currentNumberOfKeywords,
      })}
      role={shouldBeRoleButton ? 'button' : undefined}
      onMouseEnter={() => onHover && currentNumberOfKeywords && onHover()}
      onMouseLeave={() => onLeave && currentNumberOfKeywords && onLeave()}
      onClick={() => shouldBeRoleButton && onClick()}
    >
      {children}
    </WppTypography>
  )
}
